import React, {useState, useEffect} from 'react';
import {connect, useSelector} from 'react-redux';

import {
    getListingAnalyticsIfNeeded,
    getListingAnalytics,
} from 'features/dashboard/actions';
import {
    selectAccountListingAnalytics,
    selectListingAnalytics,
} from 'features/dashboard/selectors';
import {selectAccountId, selectAccountById} from 'features/accounts/selectors';
import {getAccountListingsIfNeeded} from 'features/listings/actions';
import DashboardTable from 'features/dashboard/components/DashboardTable/DashboardTable';
import {selectCurrentUser} from '../../users/selectors';
import {getCurrentMonth} from 'utils/dates';
import {withRouter} from 'utils/helpers';

let DashboardTableContainer = (props) => {
    const [showAll, setShowAll] = useState(false);
    const isFetchingAccountAnalytics = useSelector(
        (state) => state.dashboard.isFetchingAccountAnalytics,
    );
    const activeStartingDate = useSelector(
        (state) => state.dashboard.activeStartingDate,
    ) || getCurrentMonth();
    const activeListingIds = useSelector(
        (state) => state.dashboard.activeListingIds,
    ) || [];
    const listings = props.listings?.filter((listing) => activeListingIds.includes(listing.listing_id));

    useEffect(() => {
        props.getAccountListingsIfNeeded(props.accountId);
    }, []);

    const getAnalytics = (fetchNewData = false) => {
        if (listings && listings.length) {
            const accountIds = {};

            for (let key in listings) {
                if (!(listings[key] in accountIds)) {
                    accountIds[listings[key].account_id] = true;
                }
            }

            Object.keys(accountIds).forEach((accountId) => {
                if (userCanViewAnalytics(props.user, accountId)) {
                    if (fetchNewData) {
                        props.getListingAnalytics(accountId, activeStartingDate);
                    } else {
                        props.getListingAnalyticsIfNeeded(accountId, activeStartingDate);
                    }
                }
            });
        }
    };

    useEffect(() => {
        if (isFetchingAccountAnalytics) {
            getAnalytics(true);
        }
    }, [isFetchingAccountAnalytics]);

    useEffect(() => {
        getAnalytics();
    }, [props.listings]);

    const toggleShowAll = () => {
        setShowAll((prevShowAll) => {
            return !prevShowAll;
        });
    };

    const userCanViewAnalytics = (user, listingAccountId) => {
        const hasAllPerm = [
            'report-view-all-trackingAndTransactionByEvent',
            'report-view-all-clickAndCallVolumeByListing',
        ].some((permission) => {
            return user.permissions.includes(permission);
        });
        if (hasAllPerm) return true;
        return [
            'report-view-own-clickAndCallVolumeByListing',
            'report-view-own-trackingAndTransactionByEvent',
        ].some((permission) => {
            return (
                user.permissions.includes(permission) &&
                user.account_id === listingAccountId
            );
        });
    };

    return (
        <DashboardTable
            {...props}
            listings={listings}
            activeStartingDate={activeStartingDate}
            showAll={showAll}
            toggleShowAll={toggleShowAll}
            userCanViewAnalytics={userCanViewAnalytics}
        />
    );
};

DashboardTableContainer = connect(
    (state, ownProps) => {
        return {
            account: selectAccountById(state, ownProps),
            accountId: selectAccountId(state, ownProps),
            listings: selectAccountListingAnalytics(state, ownProps),
            analytics: state.dashboard,
            isFetching: state.listings.isFetching,
            modal: state.modal,
            user: selectCurrentUser(state),
        };
    },
    {
        getAccountListingsIfNeeded,
        getListingAnalytics,
        getListingAnalyticsIfNeeded,
    },
)(DashboardTableContainer);

export default withRouter(DashboardTableContainer);
